import axios from 'axios'
import { toRef } from 'vue'
const getList = async (url)=>{
	console.log("基本url",url)
	const { data:{ list } } = await axios.get(`${url}/hdTransfer/methodNormal?function=synLotteryHallNewest&version_code=9`)
	let newList = list.map((value,index)=>{
		let obj = {
			lotteryNo:value.lotteryNo,
			issue:value.issue,
			ernieDateStr:value.ernieDateStr,
			lotteryName:value.lotteryName,
			tryoutNumber:[],
			className : ''
		}
		if(value.lotteryNo!=='201'&&value.lotteryNo!=='200'&&value.lotteryNo!=='400'){
			if(value.lotteryNo!=='303'){
				obj.redball = value.openNumber.split("+")[0].split(",")
				value.openNumber.split("+")[1]?obj.blueball = value.openNumber.split("+")[1].split(","):obj.blueball =[]
				if(value.lotteryNo == '002'){
					obj.tryoutNumber = value.tryoutNumber.split(",")
					obj.className = 'fuc3d'
				}else{
					obj.tryoutNumber = []
				} 
			}else{
				obj.redball = value.openNumber.split(",")
			}
		}else{
			obj.className = 'jingcai'
		}
		return obj
	})
	return newList
}

export {
	getList
}